real.localStorage = {

    set : function(name, value) {
        try {
            window.localStorage.setItem(name, JSON.stringify(value));
        } catch (e) {
            // Just log something in console, but do not log a JavaScript error anywhere.
            console.warn('Cannot set "' + name + '" with value', value, 'to real.localStorage');
        }
    },

    get : function(name) {
        try {
            return JSON.parse(window.localStorage.getItem(name));
        } catch (e) {
            // Just log something in console, but do not log a JavaScript error anywhere.
            console.warn('Cannot get "' + name + '" from real.localStorage');
            return null;
        }
    },

    remove : function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (e) {
            // Just log something in console, but do not log a JavaScript error anywhere.
            console.warn('Cannot remove "' + name + '" from real.localStorage');
        }
    }

};
